






























import { Component, Vue } from "vue-property-decorator";
import PostCard from "../blog/PostCard.vue";
import { Settings } from "../../core/services/configService";
import { CrudService } from "../../core/services/crudService";
import store from "../../core/store";
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";

@Component({
  components: { PostCard, VueSlickCarousel },
})
export default class PopularPosts extends Vue {
  popular: any[] = [];

  get visiblePopular() {
    return (this.popular || []).slice(0, 3);
  }

  get carouselSettings() {
    const hasMany = this.visiblePopular.length > 1;
    return {
      arrows: false,
      dots: false,
      infinite: hasMany,
      slidesToShow: 1,
      slidesToScroll: 1,
      centerMode: hasMany,
      centerPadding: "0px",
      variableWidth: true,
      autoplay: hasMany,
      speed: 900,
      autoplaySpeed: 4500,
      cssEase: "ease-in-out",
    };
  }

  async mounted() {
    const url = `${Settings.HostName}/api/cztextblocks/list-with-users?count=2&popular=true`;

    const data = await new CrudService().httpGet(url);
    if (data == null) {
      console.error("Crash getting last posts");
      return;
    }
    this.popular = data;
  }

  getImage(name: string) {
    if (name !== undefined && name !== "" && name !== null) {
      return store.state.settings.Uploads + "/" + name;
    }
    return store.state.settings.Uploads + "/" + store.state.settings.Mainlogo;
  }
}
